export const reviewsConstants = {
    REVIEWS_REQUEST: 'REVIEWS_REQUEST',
    REVIEWS_SUCCESS: 'REVIEWS_SUCCESS',
    REVIEWS_LOAD_MORE_SUCCESS: 'REVIEWS_LOAD_MORE_SUCCESS',
    RESET_LOADING: 'RESET_LOADING',
    UPDATE_REVIEWS: 'UPDATE_REVIEWS',
    NEW_REVIEW_EXIST_SUCCESS: 'NEW_REVIEW_EXIST_SUCCESS',
    NEW_REVIEW_EXIST_RESET: 'NEW_REVIEW_EXIST_RESET',
};
